import { createContext, type ReactNode, useCallback, useContext, useLayoutEffect, useState } from 'react'

interface OnboardingBannerSlotValue {
  banner: ReactNode
  claim: () => () => void
}

export const OnboardingBannerContext = createContext<OnboardingBannerSlotValue | null>(null)

/** Counts the slots on the page, so the layout draws the banner itself only where a page placed none. */
export function useOnboardingBannerClaims() {
  const [claims, setClaims] = useState(0)
  const claim = useCallback(() => {
    setClaims((count) => count + 1)
    return () => setClaims((count) => count - 1)
  }, [])
  return { claim, claimed: claims > 0 }
}

/** Where a page puts the banner that sends the customer back to their application: under its title. */
export function OnboardingBannerSlot({ className }: { className?: string }) {
  const slot = useContext(OnboardingBannerContext)
  const claim = slot?.claim
  useLayoutEffect(() => claim?.(), [claim])
  if (!slot?.banner) return null
  return <div className={className}>{slot.banner}</div>
}
